import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import { ImageSliceView } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { parseAmount } from 'src/lib/utils';
import sounds from 'src/lib/sounds';
import { animateCoins } from '../../animation/CurrencyAnimation';

export default class PopupLevelUPReward extends PopupBasic {
  private rewardLabel: LangBitmapFontTextView;
  private coinIcon: ImageScaleView;
  private coinAmount: number = 0;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: uiConfig.popups.minimumWidth,
      height: 410,
      tracking: { feature: 'level', $subFeature: 'popup-level-up-reward' },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      width: this.box.style.width - 80,
      height: 80,
      x: 40,
      y: 68,
      zIndex: 1,
      size: 40,
    });

    this.box.addSubview(
      new ImageScaleView({
        height: 5,
        width: this.message.style.width,
        x: 40,
        y: 132,
        image: 'assets/ui/popups/panel_underline.png',
        scaleMethod: '3slice',
        sourceSlices: {
          horizontal: { left: 5, right: 5 },
        },
      }),
    );

    const reward = this.box.addSubview(
      new ImageSliceView({
        image: 'assets/ui/shared/lossless/inset_panel.png',
        slices: {
          left: 25,
          right: 25,
          top: 25,
          bot: 25,
        },
        centerOnOrigin: true,
        x: this.box.style.width / 2,
        y: 212,
        height: 88,
        width: 300,
      }),
    );

    this.coinIcon = new ImageScaleView({
      superview: reward,
      scaleMethod: 'contain',
      image: 'assets/ui/hud/icons/hud_coin.png',
      width: 74,
      height: 74,
      x: 10,
      y: 7,
    });

    this.rewardLabel = new LangBitmapFontTextView({
      size: 38,
      font: 'Body',
      height: 68,
      width: 196,
      verticalAlign: 'center',
      align: 'center',
      x: 90,
      y: 8,
      superview: reward,
    });

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        labelOffsetX: -4,
        labelOffsetY: -1,
        fontSize: 38,
        font: bitmapFonts('Body'),
        x: this.box.style.width / 2,
        y: this.box.style.height - 35 - 80 / 2,
        width: 229,
        height: 80,
        centerOnOrigin: true,
        localeText: () => i18n('basic.ok'),
        onClick: async () => {
          sounds.playSound('ok');
          await this.animateCoins();
          opts.close();
        },
        tracking: {
          feature: 'level',
          $subFeature: 'popup-level-up-reward-close',
        },
      }),
    );
  }

  public init({ level, reward }: { level: number; reward: number }) {
    super.init({
      title: i18n('level.reward.title'),
      message: i18n('level.reward.message', { level }),
    });

    this.coinAmount = reward;
    this.rewardLabel.localeText = () => `x ${parseAmount(this.coinAmount)}`;

    sounds.playSound('applause');
  }

  private async animateCoins() {
    const iconPos = this.coinIcon.getPosition(this.root);
    const start = {
      x: iconPos.x + this.coinIcon.style.width / 2,
      y: iconPos.y + this.coinIcon.style.height / 2,
    };

    await animateCoins({
      superview: this.root,
      start: { position: start, scale: 1 },
      count: this.coinAmount,
    });
  }
}
